module.exports = __webpack_public_path__ + "static/media/IMG_0080.c1ff419a.jpg";